import React from "react";
import PropTypes from "prop-types";

import { assertOneOf } from "../../internal/contracts";
import { useThemeA } from "../../internal/ThemeAContext";

const GAPS = ["none", "tight", "related", "content", "section", "page"];
const ALIGNS = ["start", "center", "end", "stretch"];
const GAP_CLASSES = {
  none: "akv:gap-0",
  tight: "akv:gap-1",
  related: "akv:gap-2",
  content: "akv:gap-3",
  section: "akv:gap-4",
  page: "akv:gap-8",
};
const ALIGN_CLASSES = {
  start: "akv:items-start",
  center: "akv:items-center",
  end: "akv:items-end",
  stretch: "akv:items-stretch",
};

export default function Stack({ children, gap = "content", align = "stretch" }) {
  useThemeA("Stack");
  assertOneOf("Stack", "gap", gap, GAPS);
  assertOneOf("Stack", "align", align, ALIGNS);

  return (
    <div
      className={`akv:flex akv:min-w-0 akv:flex-col ${GAP_CLASSES[gap]} ${ALIGN_CLASSES[align]}`}
      data-ak-v2-component="stack"
    >
      {children}
    </div>
  );
}

Stack.propTypes = {
  align: PropTypes.oneOf(ALIGNS),
  children: PropTypes.node.isRequired,
  gap: PropTypes.oneOf(GAPS),
};
